import React, { useEffect } from "react";
import { useNotification } from "../context/NotificationContext";
import { IoClose } from "react-icons/io5";
import { MdGroup } from "react-icons/md";

const NotificationCenter = ({ onNotificationClick = null }) => {
  const { notifications, removeNotification } = useNotification();

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes slideInRight {
        from {
          opacity: 0;
          transform: translateX(400px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  if (notifications.length === 0) return null;

  return (
    <div style={styles.container}>
      {notifications.map((notification) => (
        <div
          key={notification.id}
          style={styles.notification(notification.type)}
          onClick={() => {
            if (onNotificationClick) {
              onNotificationClick(notification);
            }
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "translateX(-2px)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "translateX(0)")}
        >
          <div style={styles.content}>
            {notification.avatar ? (
            <img
                src={notification.avatar}
                alt="avatar"
                style={styles.avatar}
            />
            ) : (
            <div style={styles.avatarFallback}>
                <MdGroup size={22} />
            </div>
            )}
            <div style={styles.textContainer}>
              <strong style={styles.senderName}>{notification.sender}</strong>
              <p style={styles.message}>{notification.message}</p>
            </div>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              removeNotification(notification.id);
            }}
            style={styles.closeButton}
            onMouseEnter={(e) => (e.target.style.opacity = "1")}
            onMouseLeave={(e) => (e.target.style.opacity = "0.6")}
          >
            <IoClose size={18} />
          </button>
        </div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    position: "fixed",
    top: 20,
    right: 20,
    zIndex: 10000,
    display: "flex",
    flexDirection: "column",
    gap: 12,
    maxWidth: 380,
  },

  notification: (type = "message") => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: "12px 14px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
    animation: "slideInRight 0.4s ease-out",
    transform: "translateX(0)",
    transition: "all 0.2s ease",
    cursor: "pointer",
  }),

  content: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    flex: 1,
    minWidth: 0,
  },

  avatar: {
    width: 44,
    height: 44,
    borderRadius: "50%",
    objectFit: "cover",
    flexShrink: 0
  },

  textContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0,
  },

  senderName: {
    fontSize: 13,
    color: "rgb(31, 58, 112)",
    fontWeight: 600,
    margin: 0,
  },

  message: {
    fontSize: 12,
    color: "#6b7280",
    margin: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  closeButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#9ca3af",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0.6,
    transition: "opacity 0.2s ease",
    flexShrink: 0,
  },
};

export default NotificationCenter;
